import store from "@/store";

const isAuthenticated = () => store.getters["isAuthenticated"];

const policyMap = {
  authenticated: isAuthenticated,
};

export default {
  run: (to, from, next) => {
    // has meta
    if (!to.meta || !to.meta.authorization || !to.meta.authorization.policies || !to.meta.authorization.policies.length) {
      next();
      return;
    }

    // is authenticated
    if (!isAuthenticated(to)) {
      next("/not-found");
      return;
    }

    // policies
    const pass = to.meta.authorization.policies.some(p => {
      const policy = policyMap[p];
      return policy && policy(to);
    });

    if (pass) {
      next();
      return;
    }

    next("/not-found");
  },
};
